import "./style.css";
import { App } from "./ui/app";
import { i18n } from "./i18n";
import { settings } from "./store/settings";
import { initSync } from "./net/sync";

i18n.init();
settings.apply();
const root = document.getElementById("app");
if (root) {
  const app = new App(root);
  app.boot();
}
// Offline-first: boots a session and mirrors progress to D1 when reachable.
initSync();

// Service worker — required for PWA installability on Chromium browsers and
// gives the game an offline shell so cold-starts work without network.
if ("serviceWorker" in navigator && location.protocol === "https:") {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      /* registration failure is non-fatal; the app still runs from network */
    });
  });
}

if (import.meta.env.DEV) {
  void import("./render/renderer").then((m) => {
    (window as unknown as { __swatch?: unknown }).__swatch = m.tierSwatch;
  });
}
